// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
/* eslint-disable new-cap, babel/new-cap */
// AND FIX ERRORS ACCORDINGLY.
import immutable, { Record, Map } from "immutable"
import moment from "moment"
import type Moment from "moment"

import { showDate, isLocalOverNight } from "../../../app/scripts/containers/helpers/partHelper"
import { FlightId } from "../types/bookingAncillary"
import { RESERVATION_PART_CONFIG } from "../consts/booking"

export const BOARDING_PASS_AVAILABILITY_NEVER = "never"

// @ts-expect-error: Flow to TS migration.
export const getDuration = (aUtc: Moment, bUtc: Moment) => moment.duration(aUtc.diff(bUtc))

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function departureArrivalFromJS(da: any) {
  return Map({
    where: immutable.fromJS(da.where),
    when: Map({
      local: moment.utc(da.when.local),
      utc: moment.utc(da.when.utc),
    }),
  })
}

const FlightRecord = Record({
  // Common with Transfer
  id: null,
  combinationId: null,
  naturalId: null,
  departure: null,
  arrival: null,
  vehicle: null,
  // @ts-expect-error: Flow to TS migration.
  type: RESERVATION_PART_CONFIG.flight.type,

  airline: null, // called carrier in Transfer
  seatmap: null,

  // Special for Flight
  number: null,
  segmentCode: null, // string
  bagsRecheckRequired: null, // bool
  guarantee: null, // bool
  isThrowawayTicket: false, // bool
  isHiddenCity: false,
  isSelfTransfer: false,

  priorityBoarding: false,
  isCabinBagsWithPriorityBoarding: false,
  operatingAirline: null,
  pnr: null, // string

  amenities: null,

  fareCategory: null,
})

export default class Flight extends FlightRecord {
  // @ts-expect-error: Flow to TS migration.
  id: FlightId

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(data: any) {
    const naturalId = [
      data.number,
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      data.airline && data.airline.get("code"),
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      data.departure && data.departure.getIn(["where", "code"]),
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      data.departure && data.departure.getIn(["when", "utc"], moment()).valueOf(),
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      data.arrival && data.arrival.getIn(["where", "code"]),
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
      data.arrival && data.arrival.getIn(["when", "utc"], moment()).valueOf(),
    ].join(":")

    super({
      ...data,
      id: data.id || naturalId,
      naturalId,
    })
  }

  /**
   * @deprecated - use native getters instead
   */
  getId() {
    return this.get("id")
  }

  /**
   * @deprecated - use native getters instead
   */
  getDeparture() {
    return this.get("departure")
  }

  /**
   * @deprecated - use native getters instead
   */
  getArrival() {
    return this.get("arrival")
  }

  getDuration() {
    return getDuration(
      this.get("arrival").get("when").get("utc"),
      this.get("departure").get("when").get("utc"),
    )
  }

  hasDeparted(): boolean {
    const now = moment().utc()

    return now.isAfter(this.getIn(["departure", "when", "utc"]))
  }

  getFrom() {
    return this.getIn(["departure", "where", "name"])
  }

  getTo() {
    return this.getIn(["arrival", "where", "name"])
  }

  getDepartureCountry() {
    return this.getIn(["departure", "where", "country"])
  }

  getArrivalCountry() {
    return this.getIn(["arrival", "where", "country"])
  }

  isLocalOverNight(): boolean {
    return isLocalOverNight(this)
  }

  showDate(prevPart: Flight): boolean {
    return showDate(prevPart, this)
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  getFlightNumber(delimiter: string = " "): string | null | undefined {
    // mmb api does not return flight_no - unable to generate flight number
    const segmentCode = this.get("segmentCode") || this.get("number")
    return segmentCode ? [this.getIn(["airline", "code"]), delimiter, segmentCode].join("") : null
  }

  getHoursToDeparture() {
    return this.getIn(["departure", "when", "utc"]).diff(moment.utc(), "hours")
  }

  // @ts-expect-error: Flow to TS migration.
  getHoursToDepartureFromCustomMoment(customMoment: Moment): number {
    return this.getIn(["departure", "when", "utc"]).diff(customMoment, "hours")
  }

  hasDifferentOperatingAirline() {
    return (
      this.get("operatingAirline") &&
      this.getIn(["operatingAirline", "name"]) !== this.getIn(["airline", "name"])
    )
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering, @typescript-eslint/no-explicit-any
  static fromPlainJS(input: any) {
    return new Flight({
      ...input,
      departure: departureArrivalFromJS(input.departure),
      arrival: departureArrivalFromJS(input.arrival),
      vehicle: input.vehicle && immutable.fromJS(input.vehicle),
      airline: immutable.fromJS(input.airline),
      operatingAirline: input.operatingAirline && immutable.fromJS(input.operatingAirline),
    })
  }
}
